import SCHeroSection from "./components/HeroSection";
import SCCitiesDirectory from "./components/CitiesDirectory";
import SCStateResources from "./components/StateResources";
import SCFAQSection, { faqs } from "./components/FAQSection";
import SCFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

const seoFaqs = faqs.map(f => ({ q: f.question, a: f.answer }));

export default function SouthCarolinaPage() {
  return (
    <>
      <CitySEOHead
        city="South Carolina"
        state="South Carolina"
        stateAbbr="SC"
        route="/states/south-carolina"
        title="South Carolina Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across South Carolina — Charleston, Columbia, Greenville, Myrtle Beach, Hilton Head. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="South Carolina, United States"
        geoPosition="33.8361;-81.1637"
        faqs={seoFaqs}
        servicesSchema={servicesList}
      />
      <div className="font-sans">
        <SCHeroSection />
        <SCCitiesDirectory />
        <SCStateResources />
        <SCFAQSection />
        <SEOCrossLinks state="SC" />
        <SCFinalCTA />
      </div>
    </>
  );
}